l = require 'app/scripts/lib/localize'

functions =

  getPermLevelAltTextForBoard: (board) ->
    level =  board.getPermLevel()
    return l(['board perms', level, 'short summary'])

  getPermLevelAltTextForTemplate: (board) ->
    level =  board.getPermLevel()
    return l(['template perms', level, 'short summary'])

  getPermLevelIconClass: (level) ->
    if level == 'org'
      'organization-visible'
    else if level == 'enterprise'
      'enterprise'
    else
      level

  getPermLevelIconClassForBoard: (board) ->
    functions.getPermLevelIconClass board.getPermLevel()

module.exports = functions
